<template>
  <Drawer v-model="detailsDrawerShow" width="90" title="班级详情">
    <!-- 班级状态 start  -->
    <div v-if="baseDetaislInfo.status === 0" class="class-status">
      <div class="status-left">
        <Icon type="ios-trash" color="red" size="25"></Icon>
        <span>班级状态：</span>
        <!-- 课班上课状态,课班上课状态，1：待上课 2：上课中 3：已完课 4：已停课 -->
        <span class="status-delete">已删除</span>
        <span class="status-delete">删除时间为{{ baseDetaislInfo.operateTime }}</span>
      </div>
    </div>
    <div v-if="baseDetaislInfo.status === 1" class="class-status">
      <div class="status-left">
        <Icon type="md-checkmark-circle" color="#29dc64" size="25"></Icon>
        <span>班级状态：</span>
        <!-- 课班上课状态,课班上课状态，1：待上课 2：上课中 3：已完课 4：已停课 -->
        <!-- <span class="status-1">{{
          classroomSubStateList[baseDetaislInfo.courseState]
        }}</span> -->
        <span class="status-1">{{
          classroomStatusListObj[baseDetaislInfo.courseState]
        }}</span>
      </div>
      <div class="status-right">
        <div
          v-if="canOperateData"
          class="click-btn-430"
          @click="handleOpenEnrollClass"
        >
          入班
        </div>
        <div class="click-btn-430" @click="handleToAttendancePage">
          班级考勤
        </div>
        <!-- <div class="click-btn-430" @click="handleToTimeTable">班级课表</div> -->
        <div
          v-if="portOrg == 0 || portOrg == 2"
          class="click-btn-430"
          @click="handleOpenActHistory"
        >
          历史操作记录
        </div>
      </div>
    </div>
    <!-- 班级状态 end  -->
    <!-- 基本信息 start  -->
    <ClassDetailBase
      :can-operate-data="canOperateData"
      :can-edit-class-data="canEditClassData"
      :base-info="baseDetaislInfo"
      :teachers-data="teachersData"
      :download-url="downloadUrl"
      @delClass="handleDelClass"
      @refresh="getCourseBaseDetails(true)"
    ></ClassDetailBase>
    <!-- 基本信息 end  -->
    <!-- 详情信息的几个tab start  -->
    <div class="tabs-box">
      <Tabs v-model="tabName" type="card">
        <TabPane label="班级信息" name="班级信息"> </TabPane>
        <TabPane label="在读学生" name="在读学生"> </TabPane>
        <TabPane label="离班学生" name="离班学生"> </TabPane>
        <TabPane label="任课教师" name="任课教师"> </TabPane>
        <TabPane label="班级课表" name="班级课表"> </TabPane>
        <TabPane label="排课规则" name="排课规则"> </TabPane>
        <TabPane label="考勤生成" name="考勤生成"> </TabPane>
        <TabPane label="课消概况" name="课消概况"> </TabPane>
      </Tabs>
    </div>
    <div v-if="detailsDrawerShow">
      <!-- <keep-alive> -->
      <component
        :is="tabComponents[tabName]"
        v-bind="tabsPorps"
        :ref="tabsRefs"
        :key="tabName"
        v-on="tabsEvents"
      ></component>
      <!-- </keep-alive> -->
    </div>
    <!-- 详情信息的几个tab end  -->
    <!-- 学生入班弹窗 start  -->
    <!-- @refreshCurrentPageList="getCourseList"
      @refreshList="initList" -->
    <EnrollStudentDrawer
      ref="EnrollStudentDrawer"
      :classroom-id="baseDetaislInfo.classroomId"
      :rel-classroom-id="baseDetaislInfo.relClassroomId"
      :school-id="baseDetaislInfo.schoolId"
      :select-student-row="baseDetaislInfo"
      :year-code="baseDetaislInfo.yearCode"
      :term-code="baseDetaislInfo.termCode"
      @refreshCurrentPageList="handleRefreshList"
    ></EnrollStudentDrawer>
    <ActHistory
      ref="actHistory"
      :classroom-id="baseDetaislInfo.classroomId"
    ></ActHistory>
    <!-- 学生入班弹窗 end  -->
  </Drawer>
</template>
<script>
import { mapMutations } from 'vuex';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import { classroomStatusList, changeDictionaries } from '@/utils/dictionary.js';
export default {
  name: 'CourseSchedulCenterDivideClassManageListDetail',
  components: {
    ClassDetailBase: () =>
      import('./ClassDetailBase.vue'),
    ClassDetailInfo: () =>
      import('./ClassDetailInfo.vue'),
    Students: () =>
      import('./Students.vue'),

    Teachers: () =>
      import('./Teachers.vue'),
    CourseSchedule: () =>
      import('./CourseSchedule.vue'),
    ClockInRule: () =>
      import('./ClockInRule.vue'),
    ClassHourConsume: () =>
      import('./ClassHourConsume.vue'),
    EnrollStudentDrawer: () =>
      import('./EnrollStudentDrawer.vue'),
    ActHistory: () =>
      import('./ActHistory.vue'),
    ClassTimeTableForDetailsDrawer: () =>
      import('./ClassTimeTableForDetailsDrawer.vue'),
    AttendanceInfo: () => import('./AttendanceInfo.vue')

  },
  // beforeRouteLeave(to, from, next) {
  //   if (
  //     to.name ===
  //     'courseSchedulCenter_divideClassManage_list_detail_classTimeTable'
  //   ) {
  //     this.SET_CACHEROUTE([
  //       'CourseSchedulCenterDivideClassManageList',
  //       'CourseSchedulCenterDivideClassManageListDetail'
  //     ]);
  //   } else if (to.name === 'courseSchedulCenter_divideClassManage_list') {
  //     this.SET_CACHEROUTE(['CourseSchedulCenterDivideClassManageList']);
  //   } else {
  //     this.SET_CACHEROUTE([]);
  //   }
  //   next();
  // },
  data() {
    return {
      classroomId: '', // 课班id
      // operateTime: this.$route.query.operateTime, // 删除时间
      baseDetaislInfo: {}, // 基础信息
      teachersData: [], // 教师列表
      classroomStatusListObj: changeDictionaries(classroomStatusList),
      classroomSubStateList: ['待上课', '上课中', '已完课', '已停课'], // 0：待上课 1：上课中 2：已完课 3：已停课
      portOrg: -1, // 处于哪个端
      hasGetApi: false, // 是否拿到数据了
      tabName: '在读学生',
      tabComponents: {
        '班级信息': 'ClassDetailInfo',
        '在读学生': 'Students',
        '离班学生': 'Students',
        '任课教师': 'Teachers',
        '班级课表': 'ClassTimeTableForDetailsDrawer',
        '排课规则': 'CourseSchedule',
        '考勤生成': 'AttendanceInfo',
        '课消概况': 'ClassHourConsume'
      },
      // tabName: '任课教师'
      uploadToken: '',
      UploadUrl: '',
      downloadUrl: '',
      loading: false,
      detailsDrawerShow: false // 是否展示侧边栏
    };
  },
  computed: {
    // 是否可以操作数据
    canOperateData() {
      // 只有运营端和学校端可以操作数据
      if (
        (this.portOrg === 0 || this.portOrg === 2) &&
        this.baseDetaislInfo.status === 1
      ) {
        return true;
      }
      return false;
    },
    // 可以编辑课班信息
    canEditClassData() {
      // 只有运营端和学校端可以操作数据
      if (
        ([0, 2, 3].includes(this.portOrg)) &&
        this.baseDetaislInfo.status === 1
      ) {
        return true;
      }
      return false;
    },
    tabsRefs() {
      const obj = {
        '班级信息': '',
        '在读学生': 'classStudents',
        '离班学生': 'leaveStudents',
        '任课教师': '',
        '班级课表': '',
        '排课规则': '',
        '考勤生成': '',
        '课消概况': ''
      };
      return obj[this.tabName];
    },
    tabsEvents() {
      const obj = {
        '班级信息': {

        },
        '在读学生': {
          studentChange: this.refreshClassList,
          resetRemoveStudent: this.resetRemoveStudent
        },
        '离班学生': {

        },
        '任课教师': {
          refreshTeacher: this.reInit
        },
        '班级课表': {
          closeDrawer: this.handleCloseDrawer
        },
        '排课规则': {
          refreshRule: this.getCourseBaseDetails(true)
        },
        '考勤生成': {
          toAddTeacher: this.toAddTeacher,
          refreshRule: this.reInit
        },
        '课消概况': {

        }
      };
      return obj[this.tabName];
    },
    tabsPorps() {
      const obj = {
        '班级信息': {
          baseInfo: this.baseDetaislInfo,
          downloadUrl: this.downloadUrl
        },
        '在读学生': {
          schoolId: this.baseDetaislInfo.schoolId,
          canOperateData: this.canOperateData,
          studentSts: 1,
          classDateBegin: this.baseDetaislInfo.classDateBegin || '',
          classroomId: this.classroomId,
          relClassroomId: this.baseDetaislInfo.relClassroomId,
          yearCode: this.baseDetaislInfo.yearCode,
          termCode: this.baseDetaislInfo.termCode
        },
        '离班学生': {
          schoolId: this.baseDetaislInfo.schoolId,
          canOperateData: this.canOperateData,
          studentSts: 0,
          classroomId: this.classroomId
        },
        '任课教师': {
          teacherSignRuleBo: this.baseDetaislInfo.teacherSignRuleBo,
          schoolId: this.baseDetaislInfo.schoolId,
          providerId: this.baseDetaislInfo.providerId,
          canOperateData: this.canOperateData,
          teachersData: this.teachersData,
          classroomId: this.classroomId,
          tableLoading: this.loading,
          baseInfo: this.baseDetaislInfo
        },
        '班级课表': {
          classroomId: this.classroomId,
          schoolId: this.baseDetaislInfo.schoolId,
          branchId: this.baseDetaislInfo.branchId
        },
        '排课规则': {
          canOperateData: this.canOperateData,
          classroomId: this.classroomId,
          classroomTotal: this.baseDetaislInfo.classroomTotal,
          classDateBegin: this.baseDetaislInfo.classDateBegin,
          arrangingRuleBo: this.baseDetaislInfo.arrangingRuleBo
        },
        '考勤生成': {
          schoolId: this.baseDetaislInfo.schoolId,
          canOperateData: this.canOperateData,
          classroomId: this.classroomId,
          schoolTimeList:
            this.baseDetaislInfo.arrangingRuleBo
              ? this.baseDetaislInfo.arrangingRuleBo.schoolTimeList
              : [],

          teacherSignRuleBo: this.baseDetaislInfo.teacherSignRuleBo,
          teachersData: this.teachersData
        },
        '课消概况': {
          baseInfo: this.baseDetaislInfo,
          classroomId: this.classroomId
        }
      };
      console.log(obj[this.tabName]);
      return obj[this.tabName];
    }
  },
  created() {
    console.log('created', '侧边栏----432');
    this.portOrg = Number(localStorage.getItem('portOrg'));
    // this.classroomId = this.$route.query.classroomId;
    this.getUploadtoken();
    // this.getCourseBaseDetails();
    // this.getTeachers();
  },

  mounted() {
    // this.getCourseBaseDetails();
    // this.getTeachers();
  },
  methods: {
    ...mapMutations(['SET_CACHEROUTE']),
    handleCloseDrawer() {
      this.detailsDrawerShow = false;
    },
    openDetailsDrawer(classroomId) {
      this.classroomId = classroomId;
      this.baseDetaislInfo = {}; // 基础信息
      this.teachersData = []; // 教师列表
      this.hasGetApi = false; // 是否拿到数据了
      this.tabName = '在读学生';
      this.getCourseBaseDetails();
      this.getTeachers();
      this.detailsDrawerShow = true;
    },
    refreshClassList() {
      this.$emit('refresh');
    },
    handleDelClass() {
      this.$emit('refresh');
      this.detailsDrawerShow = false;
    },
    reInit() {
      this.getCourseBaseDetails();
      this.getTeachers();
      this.$emit('refresh');
    },
    // 获取课班详情基础信息
    async getCourseBaseDetails(refresh = false) {
      refresh ? this.$emit('refresh') : '';
      const params = {
        classroomId: this.classroomId
      };
      const res = await courseSchedulCenter.getClassPartitionDetails(params);
      if (res.status === 200) {
        // 测试代码 star
        // res.message.teacherSignRuleBo.ruleType = 3
        //  测试代码 end
        console.log(res.message.teacherSignRuleBo, '基础信息shisha-');
        this.baseDetaislInfo = res.message;
        this.hasGetApi = true;
        if (res.message.teacherSignRuleBo) {
          res.message.teacherSignRuleBo.classroomId
            ? ''
            : (this.baseDetaislInfo.teacherSignRuleBo.classroomId = this.classroomId);
        } else {
          this.baseDetaislInfo.teacherSignRuleBo = {
            classroomId: this.classroomId,
            ruleType: 0,
            signRulesCycle: null,
            teacherIds: []
          };
        }
      }
    },
    // 获取老师列表信息
    async getTeachers() {
      const params = {
        classroomId: this.classroomId,
        teacherSts: 1 // 1:任课中 2：停课
      };
      this.loading = true;
      const res = await courseSchedulCenter.getClassPartitionTeachers(params);
      this.loading = false;
      if (res.status === 200) {
        this.teachersData = res.message;
      }
    },
    toAddTeacher() {
      this.tabName = '任课教师';
    },
    // 更新离班学生列表
    resetRemoveStudent() {
      this.$emit('refresh');
      this.$refs.leaveStudents.initList();
    },
    // 入班弹窗
    handleOpenEnrollClass() {
      // this.$Message.error('功能暂不可用!');
      // return;
      this.$nextTick(() => {
        this.$refs.EnrollStudentDrawer.open();
      });
    },
    // 历史操作记录弹窗
    handleOpenActHistory() {
      this.$refs.actHistory.handleOpen();
    },
    // 点击去到班级课表页面
    handleToTimeTable() {
      // const { href } = this.$router.resolve({
      //   name: 'courseSchedulCenter_divideClassManage_list_detail_classTimeTable',
      //   query: { classroomId: this.classroomId, branchId: this.baseDetaislInfo.branchId, schoolId: this.baseDetaislInfo.schoolId }
      // });
      // window.open(href);
      this.detailsDrawerShow = false;
      this.$router.push({
        name:
          'courseSchedulCenter_divideClassManage_list_detail_classTimeTable',
        query: {
          classroomId: this.classroomId,
          branchId: this.baseDetaislInfo.branchId,
          schoolId: this.baseDetaislInfo.schoolId
        }
      });
    },
    // 入班之后刷新学生列表(在读学生列表和离班学生列表都需要更新)
    handleRefreshList() {
      this.$emit('refresh');
      this.$refs.classStudents ? this.$refs.classStudents.initList() : '';
      this.$refs.leaveStudents ? this.$refs.leaveStudents.initList() : '';
    },
    // 上传token
    async getUploadtoken() {
      return new Promise((resolve, reject) => {
        this.$http.getUploadtoken().then(res => {
          this.uploadToken = res.message.token;
          this.UploadUrl = res.message.upUrl;
          this.downloadUrl = res.message.downUrl;
          resolve(res);
        });
      });
    },
    // 点击跳转到考勤页面
    handleToAttendancePage(row) {
      this.detailsDrawerShow = false;
      this.$router.push({
        name: 'courseSchedulCenter_divideClassManage_list_attendanceRecord',
        query: { classroomId: this.classroomId }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.class-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .status-left {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center;
    span {
      margin-left: 8px;
    }
  }
  .status-right {
    display: flex;
    align-items: center;
  }
  .status-1 {
    color: #29dc64;
  }
  .status-delete {
    color: red;
  }
}
.tabs-box {
  margin-top: 16px;
}
</style>
